import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { aderantColors } from "../../Theme/aderantColors";
import "./PersonIcon.css";
export const PersonIcon = (props) => {
    let size;
    let fontSize;
    switch (props.size) {
        case "small":
            size = 24;
            fontSize = 10;
            break;
        case "medium":
            size = 32;
            fontSize = 14;
            break;
        case "large":
            size = 48;
            fontSize = 22;
            break;
        default:
            size = props.size ?? 32;
            fontSize = size / 2 - 2;
    }
    const text = props.text ?? "";
    const nameParts = text.split(" ");
    const initials = nameParts.map((name, index) => (index === 0 || index === nameParts.length - 1 ? name.charAt(0) : "")).join("");
    const backgroundColor = props.backgroundColor ?? aderantColors.Ahsoka;
    const textColor = props.textColor ?? aderantColors.Stormtrooper;
    const borderColor = props.borderColor ?? backgroundColor;
    const id = props.id ?? "person-icon";
    const className = props.className ? props.className + ", person-icon" : "person-icon";
    const ariaLabel = props.ariaLabel ?? "Person Icon";
    const defaultStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: backgroundColor ?? aderantColors.Ahsoka,
        color: textColor ?? aderantColors.Stormtrooper,
        borderColor: borderColor,
        borderStyle: "solid",
        borderWidth: "1",
        fontSize: fontSize,
        fontWeight: 600
    };
    const combinedStyle = css({ ...defaultStyle, ...props.style });
    return (_jsx("div", { id: id, className: className, "aria-label": ariaLabel, css: combinedStyle, children: _jsx("span", { children: initials }) }));
};
